import {generateFullUrl} from "services/utils/utils";
import {get} from "lodash";

export const Comment = {
    fromServer: (data) => {
        return {
            id: data.id,
            comment: data.message.comment,
            tags: data.message.tags,
            user: {
                avatar: generateFullUrl(data.avatar),
                me: data.is_own,
                name: data.name,
                role: data.role,
                company: data.company,
                speaker: data.speaker_role
            },
            votes: {
                voted: get(data, 'votes.own_vote', false),
                total: get(data, 'votes.total', 0)
            },
            achievements: data.achievements,
            attachment: generateFullUrl(data.message.attachment)
        }
    }
}